import { createAction } from 'redux-act'

export const checkUser = createAction('Check User Request')
export const changeLanguage = createAction('Update User Language Information')



